module.exports = __webpack_public_path__ + "6814c8c7283a283c67e73f6846f522e7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/circles.png
// module id = 2740
// module chunks = 0